export default function Datenschutz() {
  return (
    <div className="legal-page" data-testid="datenschutz-page">
      <p className="section-label">Rechtliches</p>
      <h1>Datenschutzerklärung</h1>

      <h2>1. Datenschutz auf einen Blick</h2>
      <p>
        Der Schutz Ihrer personenbezogenen Daten ist uns wichtig. Wir behandeln Ihre
        personenbezogenen Daten vertraulich und entsprechend den gesetzlichen
        Datenschutzvorschriften, insbesondere der Datenschutz-Grundverordnung (DSGVO).
      </p>
      <p>
        Diese Datenschutzerklärung informiert Sie darüber, welche personenbezogenen
        Daten beim Besuch unserer Website sowie im Rahmen unserer ärztlichen Tätigkeit
        verarbeitet werden und welche Rechte Ihnen zustehen.
      </p>

      <h2>2. Verantwortliche Stelle</h2>
      <p>
        Verantwortlich für die Verarbeitung personenbezogener Daten auf dieser Website
        sowie in unserer Praxis ist:
      </p>
      <p>
        Dr. med. Inka Scheer<br />
        Praxis für Frauenheilkunde und Geburtshilfe<br />
        Nibelungenstrasse 40a<br />
        68642 Bürstadt
      </p>
      <p>
        <strong>Kontakt:</strong><br />
        Telefon: 0 6206 – 96 33 20<br />
        Fax: 0 6206 – 70 74 51<br />
        E-Mail: <a href="mailto:info@praxis-scheer.de">info@praxis-scheer.de</a>
      </p>

      <h2>3. Verarbeitung personenbezogener Daten im Rahmen der ärztlichen Behandlung</h2>
      <p>
        Im Rahmen unserer gynäkologischen Tätigkeit verarbeiten wir personenbezogene
        Daten unserer Patientinnen. Hierzu gehören insbesondere:
      </p>
      <ul>
        <li>Name und Kontaktdaten</li>
        <li>Geburtsdatum</li>
        <li>Versicherungsdaten</li>
        <li>medizinische Vorgeschichte</li>
        <li>Untersuchungsergebnisse</li>
        <li>Diagnosen</li>
        <li>Therapie- und Behandlungsinformationen</li>
      </ul>
      <p>Die Verarbeitung erfolgt zur:</p>
      <ul>
        <li>Durchführung medizinischer Untersuchungen und Behandlungen</li>
        <li>Dokumentation der Behandlung</li>
        <li>Kommunikation mit Patientinnen</li>
        <li>Abrechnung mit Krankenversicherungen</li>
        <li>Erfüllung gesetzlicher Dokumentationspflichten</li>
      </ul>
      <p>
        Gesundheitsdaten gehören zu den besonders geschützten personenbezogenen Daten
        gemäß Art. 9 DSGVO. Die Verarbeitung erfolgt gemäß Art. 9 Abs. 2 lit. h DSGVO
        sowie den geltenden gesetzlichen Regelungen für Ärztinnen und Ärzte. Alle
        Mitarbeiterinnen und Mitarbeiter unterliegen der ärztlichen Schweigepflicht.
      </p>

      <h2>4. Datenerfassung beim Besuch unserer Website</h2>
      <p>
        Beim Besuch unserer Website werden automatisch Informationen durch den Server
        verarbeitet. Dies können sein:
      </p>
      <ul>
        <li>IP-Adresse</li>
        <li>Datum und Uhrzeit des Zugriffs</li>
        <li>Browsertyp und Browserversion</li>
        <li>Betriebssystem</li>
        <li>Referrer-Adresse</li>
        <li>besuchte Seiten</li>
      </ul>
      <p>
        Diese Daten werden zur technischen Bereitstellung, Sicherheit und Optimierung
        unserer Website verarbeitet. Eine Zusammenführung mit anderen Datenquellen
        erfolgt nicht. Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO.
      </p>

      <h2>5. Cookies und Consent-Management</h2>
      <p>
        Unsere Website verwendet Cookies und vergleichbare Technologien. Cookies sind
        kleine Textdateien, die auf Ihrem Endgerät gespeichert werden und bestimmte
        Funktionen der Website ermöglichen.
      </p>
      <p>Wir unterscheiden zwischen:</p>
      <p>
        <strong>Technisch notwendigen Cookies</strong><br />
        Diese Cookies sind erforderlich, damit unsere Website technisch funktioniert.
      </p>
      <p>
        <strong>Analyse- und Drittanbieter-Dienste</strong><br />
        Dienste wie Google Analytics oder Google Maps werden erst aktiviert, wenn Sie
        hierzu über unser Cookie-Banner Ihre Einwilligung erteilen.
      </p>
      <p>
        Zur Verwaltung Ihrer Cookie-Einstellungen verwenden wir eine
        Consent-Management-Lösung von:
      </p>
      <p>Emergent</p>
      <p>
        Mit Hilfe dieser Technologie werden Ihre Einwilligungen dokumentiert und
        datenschutzkonform verwaltet. Sie können Ihre Cookie-Einstellungen jederzeit
        ändern oder Ihre Einwilligung widerrufen.
      </p>

      <h2>6. Google Analytics 4</h2>
      <p>
        Diese Website nutzt Google Analytics 4, einen Webanalysedienst der:
      </p>
      <p>
        Google Ireland Limited<br />
        Gordon House<br />
        Barrow Street<br />
        Dublin 4<br />
        Irland
      </p>
      <p>
        Google Analytics verwendet Cookies und ähnliche Technologien, um die Nutzung
        unserer Website zu analysieren. Dabei können insbesondere folgende
        Informationen verarbeitet werden:
      </p>
      <ul>
        <li>aufgerufene Seiten</li>
        <li>Nutzung der Website</li>
        <li>technische Informationen zum Endgerät</li>
        <li>Browserinformationen</li>
        <li>ungefähre Standortinformationen</li>
        <li>Interaktionen mit der Website</li>
      </ul>
      <p>
        Google Analytics wird erst nach Ihrer ausdrücklichen Einwilligung über unser
        Cookie-Consent-System aktiviert. Die Verarbeitung erfolgt auf Grundlage Ihrer
        Einwilligung gemäß Art. 6 Abs. 1 lit. a DSGVO.
      </p>
      <p>
        Eine aktive Auswertung personenbezogener Daten durch unsere Praxis erfolgt
        nicht. Die Verarbeitung erfolgt ausschließlich zur technischen Analyse und
        Verbesserung unseres Webangebotes.
      </p>
      <p>
        Weitere Informationen zum Datenschutz bei Google:{" "}
        <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">
          policies.google.com/privacy
        </a>
      </p>

      <h2>7. Google Maps</h2>
      <p>
        Diese Website nutzt Google Maps zur Darstellung unseres Praxisstandortes. Die
        Karte wird über eine Zwei-Klick-Lösung eingebunden. Vor Aktivierung der Karte
        erfolgt keine Verbindung zu Google. Erst durch Ihre aktive Zustimmung bzw. Ihren
        Klick auf die Kartenansicht wird eine Verbindung zu Google hergestellt.
      </p>
      <p>
        <strong>Anbieter:</strong><br />
        Google Ireland Limited<br />
        Gordon House<br />
        Barrow Street<br />
        Dublin 4<br />
        Irland
      </p>
      <p>
        Dabei können technische Daten, insbesondere Ihre IP-Adresse, an Google
        übertragen werden.
      </p>
      <p>
        Weitere Informationen:{" "}
        <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">
          policies.google.com/privacy
        </a>
      </p>

      <h2>8. Externe Schriftarten (Google Fonts)</h2>
      <p>
        Diese Website verwendet externe Schriftarten, um eine einheitliche und
        ansprechende Darstellung der Inhalte sicherzustellen. Beim Laden externer
        Schriftarten kann eine Verbindung zu den Servern des jeweiligen Anbieters
        hergestellt werden. Dabei können technische Informationen wie Ihre IP-Adresse
        übertragen werden. Die Einbindung erfolgt ausschließlich entsprechend den
        Vorgaben des Cookie-Consent-Managements.
      </p>

      <h2>9. Externe Bilder und Bildnachweise</h2>
      <p>
        Auf unserer Website werden Bilder verwendet, die teilweise durch externe
        Anbieter beziehungsweise Fotografen bereitgestellt wurden.
      </p>
      <p>
        <strong>Bildnachweis:</strong><br />
        Marc Fippel Fotografie<br />
        Website:{" "}
        <a href="https://marcfippel.de" target="_blank" rel="noopener noreferrer">
          marcfippel.de
        </a>
      </p>
      <p>
        Bei der Darstellung der Bilder werden keine personenbezogenen Daten von
        Besucherinnen und Besuchern verarbeitet, sofern keine externen Dienste des
        jeweiligen Anbieters eingebunden werden.
      </p>

      <h2>10. Kontaktaufnahme per E-Mail</h2>
      <p>
        Eine Kontaktaufnahme über ein Kontaktformular ist nicht möglich. Sollten Sie
        uns per E-Mail kontaktieren, werden Ihre Angaben ausschließlich zur Bearbeitung
        Ihrer Anfrage verarbeitet.
      </p>
      <p>
        Bitte beachten Sie, dass eine unverschlüsselte E-Mail-Kommunikation keinen
        vollständigen Schutz sensibler medizinischer Informationen gewährleisten kann.
        Bitte übermitteln Sie keine vertraulichen Gesundheitsdaten unverschlüsselt per
        E-Mail.
      </p>

      <h2>11. Speicherdauer</h2>
      <p>
        Wir speichern personenbezogene Daten nur solange, wie dies für die jeweiligen
        Zwecke erforderlich ist oder gesetzliche Aufbewahrungspflichten bestehen.
        Medizinische Dokumentationen werden entsprechend den gesetzlichen Vorgaben für
        ärztliche Unterlagen aufbewahrt. Nach Ablauf dieser Fristen werden Daten
        gelöscht oder entsprechend den gesetzlichen Anforderungen gesperrt.
      </p>

      <h2>12. Bewerbungen und Bewerberdaten</h2>
      <p>
        Wenn Sie sich bei uns bewerben, verarbeiten wir die von Ihnen übermittelten
        personenbezogenen Daten zum Zweck der Durchführung des Bewerbungsverfahrens.
        Dies betrifft insbesondere:
      </p>
      <ul>
        <li>Name und Kontaktdaten</li>
        <li>Bewerbungsunterlagen (z. B. Lebenslauf, Zeugnisse und Qualifikationsnachweise)</li>
        <li>Angaben zu Ihrer beruflichen Qualifikation und Ihrem bisherigen Werdegang</li>
        <li>Informationen aus der Kommunikation im Rahmen des Bewerbungsprozesses</li>
      </ul>
      <p>Die Verarbeitung erfolgt ausschließlich zur:</p>
      <ul>
        <li>Prüfung Ihrer Bewerbung</li>
        <li>Durchführung des Bewerbungsverfahrens</li>
        <li>Entscheidung über die Begründung eines Beschäftigungsverhältnisses</li>
      </ul>
      <p>
        Die Verarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO in
        Verbindung mit § 26 Bundesdatenschutzgesetz (BDSG).
      </p>
      <p>
        Bewerbungsdaten werden vertraulich behandelt und ausschließlich von den
        Personen verarbeitet, die am Bewerbungsprozess beteiligt sind. Eine Weitergabe
        Ihrer Bewerbungsdaten an Dritte erfolgt nicht.
      </p>
      <p>
        Sofern Bewerbungsunterlagen besondere Kategorien personenbezogener Daten gemäß
        Art. 9 DSGVO enthalten, beispielsweise Gesundheitsdaten, erfolgt die
        Verarbeitung nur, soweit dies gesetzlich zulässig ist oder eine ausdrückliche
        Einwilligung vorliegt.
      </p>
      <p>
        Nach Abschluss des Bewerbungsverfahrens werden Ihre Daten gelöscht, sofern
        keine gesetzlichen Aufbewahrungspflichten bestehen oder Sie einer weiteren
        Speicherung ausdrücklich zugestimmt haben.
      </p>
      <p>
        Sollten wir Ihre Bewerbung für zukünftige Stellenangebote berücksichtigen
        möchten, erfolgt eine längere Speicherung Ihrer Daten ausschließlich mit Ihrer
        vorherigen Einwilligung. Eine erteilte Einwilligung können Sie jederzeit mit
        Wirkung für die Zukunft widerrufen.
      </p>

      <h2>13. Ihre Rechte</h2>
      <p>Sie haben folgende Rechte:</p>
      <ul>
        <li>Recht auf Auskunft gemäß Art. 15 DSGVO</li>
        <li>Recht auf Berichtigung gemäß Art. 16 DSGVO</li>
        <li>Recht auf Löschung gemäß Art. 17 DSGVO</li>
        <li>Recht auf Einschränkung der Verarbeitung gemäß Art. 18 DSGVO</li>
        <li>Recht auf Datenübertragbarkeit gemäß Art. 20 DSGVO</li>
        <li>Recht auf Widerspruch gemäß Art. 21 DSGVO</li>
      </ul>
      <p>
        Sie können eine erteilte Einwilligung jederzeit mit Wirkung für die Zukunft
        widerrufen.
      </p>

      <h2>14. Beschwerderecht bei einer Aufsichtsbehörde</h2>
      <p>
        Sie haben das Recht, sich bei einer Datenschutzaufsichtsbehörde zu beschweren.
      </p>

      <h2>15. Ansprechpartner Datenschutz</h2>
      <p>Bei Fragen zum Datenschutz wenden Sie sich bitte an:</p>
      <p>
        Dr. med. Inka Scheer<br />
        <a href="mailto:info@praxis-scheer.de">info@praxis-scheer.de</a>
      </p>

      <h2>16. Aktualisierung dieser Datenschutzerklärung</h2>
      <p>
        Wir behalten uns vor, diese Datenschutzerklärung anzupassen, wenn rechtliche,
        technische oder organisatorische Änderungen dies erforderlich machen.
      </p>
      <p><em>Stand: Juni 2026</em></p>
    </div>
  );
}
